export { legalAgreements } from '../en/legal-agreements';
